import common from './Common';
import lcopsDashboard from './Dashboard';
import datacenters from './Datacenter';
import environments from './Environments';
import requests from './Requests';
import requestStatus from './RequestStatus';
import settings from './Settings';
import system from './System';
import environmentWorkflow from './workflows/EnvironmentWorkflow';
import upgradeWorkflow from './workflows/UpgradeWorkflow';

export const lcopsReducers = () => ({
  lcopsDashboard,
  common,
  environmentWorkflow,
  upgradeWorkflow,
  datacenters,
  settings,
  environments,
  requests,
  requestStatus,
  system
});

export default lcopsReducers;
